import { DirectusUser } from "@directus/sdk";
import { UserInterface } from "~/entities/user";

export function castUserToDirectusUser(user: UserInterface): DirectusUser<any> {
  return user.data as unknown as DirectusUser<any>;
}

